import { useTheme } from '@mui/material/styles'
import * as React from 'react'
import { FC, useCallback, useState } from 'react'
import { Role } from '@user/store/roles/typings'
import Card from '@mui/material/Card'
import { AlertDialogSlide, MoreButton } from '@sales-center/components'

interface Props {
  role: Role
  onDelete: (id: number) => void
  onEdit: (id: number) => void
}

export const RoleCard: FC<Props> = (props) => {
  const {
    role: { id, name, marketingProduct, systemCreated, usersCount },
    onDelete,
    onEdit,
  } = props

  const [open, setOpen] = useState(false)
  const confirmDelete = useCallback(() => setOpen(true), [])
  const cancelDelete = useCallback(() => setOpen(false), [])

  const editClick = useCallback(() => onEdit(id), [id, onEdit])
  const deleteClick = useCallback(() => {
    setOpen(false)
    onDelete(id)
  }, [id, onDelete])

  const theme = useTheme()

  return (
    <>
      <AlertDialogSlide
        open={open}
        title="Delete Role?"
        message="Are you sure you want to delete this role?"
        okButtonText="Delete"
        okClick={deleteClick}
        cancelButtonText="Cancel"
        cancelClick={cancelDelete}
      />
      <Card
        square
        elevation={2}
        style={{
          fontSize: '14px',
          fontFamily: 'Source Sans Pro Semibold',
          padding: theme.spacing(2),
          marginBottom: theme.spacing(2),
        }}
      >
        <div
          style={{
            display: 'flex',
            fontSize: '16px',
            marginBottom: theme.spacing(1.5),
          }}
        >
          {name}
          <MoreButton
            dataTestId={`roleCardMoreBtn-${id}`}
            style={{ marginLeft: 'auto' }}
            options={[
              {
                label: 'Edit',
                onClick: editClick,
                tooltipText: undefined,
              },
              {
                label: 'Delete',
                onClick: confirmDelete,
                disabled: systemCreated || usersCount > 0,
                tooltipText: systemCreated
                  ? 'Cannot delete system created role'
                  : usersCount > 0
                    ? 'Remove all users that are using this role to delete it.'
                    : undefined,
              },
            ]}
          />
        </div>

        <div>
          Product
          <div>{marketingProduct}</div>
        </div>
      </Card>
    </>
  )
}
RoleCard.displayName = 'RoleCard'
